import React from "react";
import Chip from "@mui/material/Chip";
import NotificationImportant from "@mui/icons-material/NotificationImportant";
import Archive from "@mui/icons-material/Archive";
import Star from "@mui/icons-material/Star";
import Lock from "@mui/icons-material/Lock";
import { useMyEntitlements } from "@seabrookstudios/pitch2table";

/**
 * @type {Object.<import("@seabrookstudios/pitch2table-core").Filter<any>["icon"], React.ComponentType>}
 */
const Icons = {
  bell: NotificationImportant,
  star: Star,
  archive: Archive,
};

/**
 * @template T
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").Filter<T>[]} props.filters
 * @param {string} props.filter
 * @param {(label: string) => void} props.onFilterClicked
 */
export const FilterList = ({ filters = [], filter, onFilterClicked }) => {
  const { data: entitlements } = useMyEntitlements();

  return filters
    .filter((filter) => (filter.hideForUser ? !filter.hideForUser(entitlements) : true))
    .filter((filter) => (filter.locked ? !filter.locked(entitlements) : true))
    .map(({ icon, label, count, locked }) => {
      const onChipClicked = (e) => {
        e.preventDefault();
        onFilterClicked(label);
      };

      const isLocked = locked ? locked(entitlements) : false;
      const FilterIcon = Icons[icon];
      const displayLabel = count > 0 ? `${label} (${count})` : label;

      return (
        <Chip
          id={label}
          icon={isLocked ? <Lock /> : FilterIcon && <FilterIcon />}
          key={label}
          label={displayLabel}
          onClick={onChipClicked}
          variant={label === filter ? "filled" : "outlined"}
          color={label === filter ? "secondary" : "default"}
          disabled={isLocked}
        />
      );
    });
};
